import User from "../../models/user.model";

export interface AccountConfirmationState {
    showModal: boolean,
    byAction: boolean,
    errorMessage?: string,
    confirmationLoading: boolean,
    confirmationSuccess: boolean,
    confirmationErrorMessage?: string,
}

export interface AuthState {
    authenticated: boolean;
    token: string | null;
    user: User | null;
    wasLogoutSolicited: boolean;
    updateTermAccept: boolean;
    accountConfirmation: AccountConfirmationState;
}

export const INITIAL_STATE: AuthState = {
    authenticated: false,
    token: null,
    user: null,
    wasLogoutSolicited: false,
    updateTermAccept: false,
    accountConfirmation: {
        showModal: false,
        byAction: false,
        errorMessage: undefined,
        confirmationLoading: false,
        confirmationSuccess: false,
        confirmationErrorMessage: undefined,
    }
}

export enum AuthActionTypes {
    UPDATE_AUTHENTICATION_TOKEN = '@auth/UPDATE_AUTHENTICATION_TOKEN',
    USER_IS_NOT_VERIFIED = "@auth/USER_IS_NOT_VERIFIED",
    USER_EMAIL_VALIDATED = "@auth/USER_EMAIL_VALIDATED",
    SETUP_COMPLETED = '@sign/SETUP_COMPLETED',

    GET_USER = '@auth/GET_USER',
    GET_USER_SUCCESS = '@auth/GET_USER_SUCCESS',
    GET_USER_ERROR = '@auth/GET_USER_ERROR',

    UPDATE_TERM_ACCEPT = '@auth/UPDATE_TERM_ACCEPT',
    UPDATE_TERM_ACCEPT_SUCCESS = '@auth/UPDATE_TERM_ACCEPT_SUCCESS',
    UPDATE_TERM_ACCEPT_ERROR = '@auth/UPDATE_TERM_ACCEPT_ERROR',

    FETCH_SHOW_ACCOUNT_CONFIRMATION_MODAL = "@auth/FETCH_SHOW_MODAL",
    FETCH_HIDE_ACCOUNT_CONFIRMATION_MODAL = "@auth/FETCH_HIDE_MODAL",

    SEND_EMAIL_ACCOUNT_CONFIRMATION = "@auth/SEND_EMAIL_ACCOUNT_CONFIRMATION",
    SEND_EMAIL_ACCOUNT_CONFIRMATION_SUCCESS = "@auth/SEND_EMAIL_ACCOUNT_CONFIRMATION_SUCCESS",
    SEND_EMAIL_ACCOUNT_CONFIRMATION_ERROR = "@auth/SEND_EMAIL_ACCOUNT_CONFIRMATION_ERROR",

    ACCOUNT_CONFIRMATION = "@auth/ACCOUNT_CONFIRMATION",
    ACCOUNT_CONFIRMATION_SUCCESS = "@auth/ACCOUNT_CONFIRMATION_SUCCESS",
    ACCOUNT_CONFIRMATION_ERROR = "@auth/ACCOUNT_CONFIRMATION_ERROR",
}
